// extracted by mini-css-extract-plugin
module.exports = {"MenuButton":"menuButtonStyles_MenuButton__3RH3U","MenuButtonIcon":"menuButtonStyles_MenuButtonIcon__GCMSt","MenuButtonArrow":"menuButtonStyles_MenuButtonArrow__1AnE6"};